import { render, staticRenderFns } from "./StudyPlan.vue?vue&type=template&id=1aa626e6&scoped=true&"
import script from "./StudyPlan.vue?vue&type=script&lang=js&"
export * from "./StudyPlan.vue?vue&type=script&lang=js&"
import style0 from "./StudyPlan.vue?vue&type=style&index=0&id=1aa626e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa626e6",
  null
  
)

export default component.exports